import { StepClass } from '../common';
import { generateUUID } from '../utils/generateUUID';
import { STEP_PREFIXES } from './constants';
export function create(partial = {}) {
    return Object.assign({ uuid: generateUUID(STEP_PREFIXES[StepClass.MediaSettings]), className: StepClass.MediaSettings, title: '', description: [], isRequired: false, revision: 0 }, partial);
}
